module.exports = __webpack_public_path__ + "static/media/default-avatar.8a5f0958.svg";